import { render } from "./share-modal-settings-passcode.vue?vue&type=template&id=47ec45af&scoped=true&ts=true"
import script from "./share-modal-settings-passcode.vue?vue&type=script&lang=ts"
export * from "./share-modal-settings-passcode.vue?vue&type=script&lang=ts"

import "./share-modal-settings-passcode.vue?vue&type=style&index=0&id=47ec45af&lang=scss&scoped=true"
import "./share-modal-settings-passcode.vue?vue&type=style&index=1&id=47ec45af&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ec45af"]])

export default __exports__